/* eslint-disable jsx-a11y/anchor-is-valid */
import { useSearchParams } from 'react-router-dom'
import ChatLeftPanel from '../../components/conversations/ChatLeftPanel/index'
import ChatRoom from '../../components/conversations/ChatRoom'
import { useContext, useState } from 'react'
import ChatHeaderComponents from '../../components/conversations/ChatHeaderComponents'
import ChatContext from '../../context/ChatContext'
import CsvDownloader from 'react-csv-downloader'
import { GET_SESSION_BY_BG_ACCOUNT_ID } from '../../graphql/query'
import { useQuery } from '@apollo/client'

const AllChats: React.FC<any> = () => {
  // Team select state and mock data (replace with real data source if needed)
  const [selectedTeam, setSelectedTeam] = useState("1");
  const theTeams = [
    { id: "1", name: "Website chatbot history" },
    { id: "2", name: "Human hand off history " },
  
  ];
  const [isData2, setIsData2] = useState()
  const [isData3, setIsData3] = useState()
  const [searchParams, setSearchParams] = useSearchParams()
  let chatRoomID: number = 0
  // let agentID: number = 0

  const type = searchParams.get('type')
  console.log(type)
  const chatRoomId = searchParams.get('chatRoomId')
  // const agentId = searchParams.get('agentId')
  const [disabledIndexes, setDisabledIndexes] = useState<any[]>([])
  const [chatPanels, setChatPanels] = useState<any[]>([])
  const [applicationIds, setApplicationIds] = useState<number[]>([])
  const maxPanels = 3
  const { state, setState } = useContext(ChatContext)

  const handleOpenChat = (user: any) => {
    if (chatPanels.length >= maxPanels) {
      alert(
        `You can't open more than ${maxPanels} chat panels. Please close one to open a new one.`
      )
      return
    }

    // Check if the chat panel for this user is already open
    if (chatPanels.find((panel) => panel.user.id === user.id)) {
      alert('Chat panel for this user is already open.')
      return
    }

    // Add a new panel with user data
    const newPanel = { id: Date.now(), user, isMinimized: false }
    setChatPanels([...chatPanels, newPanel])
    setDisabledIndexes([...disabledIndexes, user.id])

    if (!!user.emailVerified) {
      setState((prevState: any) => ({
        ...prevState,
        panelBasedConversation: [
          ...prevState.panelBasedConversation,
          { agentId: parseInt(user.id), agentName: user.name, conversation: [],onlineStatus: user.onlineStatus }
        ]
      }))
    } else {
      setState((prevState: any) => ({
        ...prevState,
        panelBasedConversation: [
          ...prevState.panelBasedConversation,
          { chatRoomId: parseInt(user.id), conversation: [],onlineStatus: user.onlineStatus }
        ]
      }))
    }
  }

  // Function to handle closing a chat panel
  const handleCloseChat = (id: any) => {
    const closedPanel = chatPanels.find((panel: { id: any }) => panel.id === id)
    setChatPanels(chatPanels.filter((panel: { id: any }) => panel.id !== id))

    if (closedPanel) {
      setDisabledIndexes(disabledIndexes.filter((userId: any) => userId !== closedPanel.user.id))
      setState((prevState: any) => {
        return {
          ...prevState,
          panelBasedConversation: prevState.panelBasedConversation.filter((conversation: any) => {
            return (
              conversation.chatRoomId !== parseInt(closedPanel.user.id) &&
              conversation.agentId !== parseInt(closedPanel.user.id)
            )
          })
        }
      })
    }
  }

  const handleMinimizeChat = (id: number) => {
    setChatPanels(
      chatPanels.map((panel: { id: number; isMinimized: any }) =>
        panel.id === id ? { ...panel, isMinimized: !panel.isMinimized } : panel
      )
    )
  }
  // Check if chatRoomId present or not in the url params
  if (chatRoomId !== null && chatRoomId !== undefined) {
    // Check if it is a NaN value or correct chatRoomId
    chatRoomID = !!Number(chatRoomId) ? Number(chatRoomId) : 0
    if (chatRoomID === 0 || chatRoomID > 2147483648) {
      //GraphQL's Int type typically supports values between 2,147,483,648 and 2,147,483,647
      // Create a new URL without 'chatRoomId'
      const url = new URL(window.location.href)
      url.searchParams.delete('chatRoomId')
      // Update the URL without 'chatRoomId'
      window.history.replaceState({}, document.title, url.toString())
    } else {
      // Check if chatRoomId is valid when it is an integer
      // This validation may be implemented inside ChatRoom / ChatInner component
    }
  }

  // Check if agentId present or not in the url params
  // if (agentId !== null && agentId !== undefined) {
  //   // Check if it is a NaN value or correct agentId
  //   agentID = !!Number(agentId) ? Number(agentId) : 0
  //   if (agentID === 0 || agentID > 2147483648) {
  //     //GraphQL's Int type typically supports values between 2,147,483,648 and 2,147,483,647
  //     // Create a new URL without 'agentId'
  //     const url = new URL(window.location.href)
  //     url.searchParams.delete('chatRoomId')
  //     // Update the URL without 'agentId'
  //     window.history.replaceState({}, document.title, url.toString())
  //   } else {
  //     // Check if agentId is valid when it is an integer
  //   }
  // }
  const { data, loading, error, refetch } = useQuery(GET_SESSION_BY_BG_ACCOUNT_ID, {
    variables: {
      input: { applicationIds: applicationIds }
    },
    context: {
      headers: {
        'access-control-allow-methods': 'Report'
      }
    }
  })

  const formatDate = (dateString: string) => {
    if (!dateString) return ''

    return new Date(dateString)
      .toLocaleString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false // 24-hour format
      })
      .replace(',', '') // Ensures CSV treats it as a single value
  }

  const calculateTimeDifference = (start: string, end: string) => {
    if (!start || !end) return ''

    const startTime = new Date(start)
    const endTime = new Date(end)
    const diffMs = endTime.getTime() - startTime.getTime()

    if (diffMs < 0) return '' // In case endDate is earlier than startDate

    const hours = Math.floor(diffMs / (1000 * 60 * 60))
    const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60))

    return `${hours}h ${minutes}m`
  }

  const sessions = data?.getSessionByBgaccountId || []
  const tableData = sessions.map((session: any, index: number) => ({
    'Serial Number': (index + 1).toString(),
    'Bot Name': session?.botName || '',
    'Chat Room ID': `CONV-${session?.chatRoomId}`,
    'Assigned Agent': session?.agentName || '',
    'Resolved By': session?.reslovedBy ? 'By Agent' : 'By Bot',
    'Start Date': formatDate(session?.startDate),
    'End Date': formatDate(session?.endDate),
    'Chat Duration': calculateTimeDifference(session?.startDate, session?.endDate)
  }))

  const updateApplicationIds = (newIds: number[]) => {
    setApplicationIds(newIds)
    refetch({ input: { applicationIds: newIds } }) // Trigger API re-fetch
  }

  return (
    <div className='card card-flush'>
        {type === 'Resolved' && (
          <div className='d-flex justify-content-between align-items-center me-2'>
            {/* Team Select - Website Type Only */}
            {type === 'Resolved' && (
              <div className="w-100 mw-250px" style={{ position: "relative", maxWidth: 250 }}>
                <div
                  style={{
                    position: "absolute",
                    top: "-9px",
                    left: "5px",
                    background: "white",
                  }}
                >
                  <p
                    style={{
                      margin: "0",
                      fontSize: "12px",
                    }}
                  >
                    Select history
                  </p>
                </div>
                <select
                  className="form-select"
                  value={selectedTeam}
                  onChange={(e: any) => setSelectedTeam(e.target.value)}
                >
                  <option value="">Select history</option>
                  {theTeams && theTeams.map((team: any) => (
                    <option key={team.id} value={team.id}>
                      {team.name}
                    </option>
                  ))}
                </select>
              </div>
            )}
            {/* End Team Select */}
          
            <CsvDownloader filename='chat_history' extension='.csv' datas={tableData}>
              <button className='btn btn-primary me-2'>
                <i className='bi bi-download fs-2 me-3'></i>
                Download Chat Report
              </button>
            </CsvDownloader>
          </div>
        )}
        {type === 'Assigned' && (
          <div className='card-header d-flex align-items-center'>
            <div className='fs-2 fw-bold text-black-700'>Chat</div>
            <div>
              <ChatHeaderComponents />
            </div>
          </div>
        )}
        <div className='d-flex flex-column flex-lg-row mt-4 mx-4'>
          {(type === 'Unassigned' ||
            type === 'Assigned' ||
            type === 'Resolved' ||
            type === 'Chat-Report') && (
            <ChatLeftPanel
              type={type}
              chatRoomID={chatRoomID}
              isData2={isData2}
              isData3={isData3}
              handleOpenChat={handleOpenChat}
              disabledIndexes={disabledIndexes}
              updateApplicationIds={updateApplicationIds}
            />
          )}
          {(type === 'Unassigned' ||
            type === 'Assigned' ||
            type === 'Resolved' ||
            type === 'Chat-Report') && (
            // !!chatRoomID &&
            // chatRoomID > 0 &&
            // chatRoomID <= 2147483648 &&
            <ChatRoom
              type={type}
              chatRoomID={chatRoomID}
              // agentID={agentID}
              searchParams={searchParams}
              setSearchParams={setSearchParams}
              setIsData2={setIsData2}
              setIsData3={setIsData3}
              handleOpenChat={handleOpenChat}
              handleCloseChat={handleCloseChat}
              handleMinimizeChat={handleMinimizeChat}
              chatPanels={chatPanels}
              disabledIndexes={disabledIndexes}
            />
          )}
        </div>
      </div>
  )
}

export default AllChats

// Refer to this article to know more about comparing Arrays: https://masteringjs.io/tutorials/fundamentals/compare-arrays
